import { render } from "./Apart.vue?vue&type=template&id=22dfa5ce&ts=true"
import script from "./Apart.vue?vue&type=script&lang=ts"
export * from "./Apart.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__